/* eslint-disable */
import convertList from '../convertList';
import filters from '../filters';
// import getDetail from '../getDetail/getPeopleDetailByUin';
// import sign from '../sign';
import  { envDomain } from '@/common/contact-selector/utils/domainConfig'
import errorAction from '@/components/contact-selector/enum/errorAction'
// 加载临界值，小于该数字直接加载详情
const LOAD_DETAIL_NUM = 100;

export default function(config) {
    const moreConfig = {
        totalState: false
    };
    const selfConfig = config.extendConfig && config.extendConfig[config.base.field] || {};
    let count = 0;
    let uins = [];
    const datasource = [];
        return new Promise((resolve, reject) => {
            _getQQFriendUinByPagination()
                .then(res => {
                    console.log('getQQFriend new:', JSON.stringify(res));
                    if (window.parseInt(res.code) === 0 && res.data && res.data.groups) {
                        res.data.groups.forEach(group => {
                            datasource.push({
                                ...group,
                                uins: []
                            });
                        });
                        return new Promise(resolve => {
                            resolve(datasource);
                        });
                    }
                    throw res;
                })
                .then(detailList => {
                    config = Object.assign(config, moreConfig);
                    const newList = convertList(detailList, {
                        list: 'uins',
                        groupName: 'name'
                    }, config);
                    resolve(filters.setKfuinTypeInList(newList));
                })
                .catch(err => {
                    if(`${err.code}` === '150203'){
                        err.action = errorAction.ShowErrorInNoData
                        err.msg = '当前用户无“我的好友”权限，请联系管理员添加'
                    }
                    reject(err);
                });
        });
}

function _getQQFriendUinByPagination() {
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/qq/qqFriendGroups`);
}
